export {
  default as decksSlice,
  addCard,
  editDeck,
  newDeck,
  removeCard,
  deleteDeck,
  setDeckName,
} from './decks.slice';
